/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LootboxRedemption
 */
export interface LootboxRedemption {
    /**
     * 
     * @type {string}
     * @memberof LootboxRedemption
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LootboxRedemption
     */
    lootboxName: string;
    /**
     * 
     * @type {string}
     * @memberof LootboxRedemption
     */
    prizeRevealName: string;
    /**
     * 
     * @type {string}
     * @memberof LootboxRedemption
     */
    transactionHash?: string;
    /**
     * 
     * @type {string}
     * @memberof LootboxRedemption
     */
    promoCode?: string;
    /**
     * 
     * @type {string}
     * @memberof LootboxRedemption
     */
    createdAt: string;
}

export function LootboxRedemptionFromJSON(json: any): LootboxRedemption {
    return LootboxRedemptionFromJSONTyped(json, false);
}

export function LootboxRedemptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootboxRedemption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lootboxName': json['lootboxName'],
        'prizeRevealName': json['prizeRevealName'],
        'transactionHash': !exists(json, 'transactionHash') ? undefined : json['transactionHash'],
        'promoCode': !exists(json, 'promoCode') ? undefined : json['promoCode'],
        'createdAt': json['createdAt'],
    };
}

export function LootboxRedemptionToJSON(value?: LootboxRedemption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lootboxName': value.lootboxName,
        'prizeRevealName': value.prizeRevealName,
        'transactionHash': value.transactionHash,
        'promoCode': value.promoCode,
        'createdAt': value.createdAt,
    };
}


